<template>
  <div>
    <b-card
      no-body
      class="mb-2"
    >
      <b-card-header class="d-flex align-items-center">
        <feather-icon
          icon="PlayCircleIcon"
          size="20"
          class="text-primary mr-1"
        />
        <h4 class="mb-0">
          Test Studio
        </h4>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Başlangıç</label>
            <b-form-input
              v-model="form.startAt"
              type="date"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Bitiş</label>
            <b-form-input
              v-model="form.endAt"
              type="date"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <div class="d-flex align-items-center justify-content-between">
              <label class="font-small-3 text-muted mb-0">Test modu</label>
              <b-button
                size="sm"
                variant="flat-secondary"
                class="p-25"
                title="Test modlarını açıkla"
                @click="$bvModal.show('test-mode-help-modal')"
              >
                <feather-icon
                  icon="HelpCircleIcon"
                  size="14"
                />
              </b-button>
            </div>
            <b-form-select
              v-model="form.testMode"
              :options="testModeOptions"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Data modu</label>
            <b-form-select
              v-model="form.dataMode"
              :options="dataModeOptions"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Provider</label>
            <b-form-select
              v-model="form.providerKind"
              :options="providerOptions"
              :disabled="form.dataMode === 'RANDOM'"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Coin limiti</label>
            <b-form-input
              v-model.number="form.coinLimit"
              type="number"
              min="1"
              max="200"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Mum limiti</label>
            <b-form-input
              v-model.number="form.candleLimit"
              type="number"
              min="50"
              max="1500"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-1 d-flex align-items-end"
          >
            <b-form-checkbox
              v-model="form.applySafetyControls"
              switch
            >
              MFE / güvenlikleri kullan
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-1 d-flex align-items-end"
          >
            <b-form-checkbox
              v-model="form.applyPositionGuardian"
              switch
            >
              Position Guardian kullan
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-1 d-flex align-items-end"
          >
            <b-form-checkbox
              v-model="form.applyCloseFollow"
              switch
              :disabled="!form.applyPositionGuardian"
            >
              Yakın Takip kullan
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-1 d-flex align-items-end"
          >
            <b-form-checkbox
              v-model="form.runtimeParityMode"
              switch
            >
              Runtime parity modu
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-alert
          v-if="providerLimitWarning"
          show
          variant="warning"
          class="mb-1"
        >
          <strong>Provider limit riski:</strong> {{ providerLimitWarning }}
        </b-alert>

        <b-row v-if="usesRebuildLikeMode">
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Bot sayısı</label>
            <b-form-input
              v-model.number="form.botCount"
              type="number"
              min="1"
              max="50"
            />
          </b-col>
          <b-col
            v-if="form.testMode === 'REBUILD_FROM_EDGES'"
            cols="12"
            md="3"
            class="mb-1 d-flex align-items-end"
          >
            <b-form-checkbox
              v-model="form.useRuntimeIndicatorSelection"
              switch
            >
              Runtime indikatör seçimi
            </b-form-checkbox>
          </b-col>
          <b-col
            v-if="form.testMode === 'REBUILD_FROM_EDGES'"
            cols="12"
            md="3"
            class="mb-1 d-flex align-items-end"
          >
            <b-form-checkbox
              v-model="form.useRuntimeIndicatorPool"
              switch
            >
              Top havuz mantığı
            </b-form-checkbox>
          </b-col>
          <b-col
            v-if="form.testMode === 'REBUILD_FROM_EDGES'"
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Rescan aralığı dk</label>
            <b-form-input
              v-model.number="form.virtualRescanIntervalMinutes"
              type="number"
              min="1"
              max="10080"
            />
          </b-col>
          <b-col
            v-if="form.testMode === 'REBUILD_FROM_EDGES'"
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Rescan süresi dk</label>
            <b-form-input
              v-model.number="form.virtualRescanDurationMinutes"
              type="number"
              min="0"
              max="10080"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Market</label>
            <b-form-select
              v-model="form.market"
              :options="marketOptions"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Edge türü</label>
            <b-form-select
              v-model="form.edgeKind"
              :options="edgeKindOptions"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Timeframe</label>
            <b-form-input
              v-model="form.timeframesRaw"
              placeholder="5m,15m"
            />
          </b-col>
        </b-row>

        <b-row v-if="usesRebuildLikeMode">
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">TP %</label>
            <b-form-input
              v-model.number="form.tpPerc"
              type="number"
              min="0.01"
              step="0.05"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">SL %</label>
            <b-form-input
              v-model.number="form.slPerc"
              type="number"
              min="0.01"
              step="0.05"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Kaldıraç</label>
            <b-form-input
              v-model.number="form.leverage"
              type="number"
              min="1"
              step="1"
            />
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Komisyon/Yön %</label>
            <b-form-input
              v-model.number="form.commissionPerSide"
              type="number"
              min="0"
              step="0.01"
            />
          </b-col>
        </b-row>

        <b-row v-if="form.dataMode === 'RANDOM'">
          <b-col
            cols="12"
            md="3"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Random seed</label>
            <b-form-input
              v-model="form.randomSeed"
              placeholder="test-studio"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-1"
          >
            <label class="font-small-3 text-muted">Volatilite %</label>
            <b-form-input
              v-model.number="form.randomVolatility"
              type="number"
              min="0.05"
              max="20"
              step="0.05"
            />
          </b-col>
        </b-row>

        <b-alert
          show
          variant="light"
          class="mb-0"
        >
          <div class="d-flex flex-wrap align-items-center">
            <span class="mr-2">Seçili hedef: <strong>{{ selectedTargetIds.length }}</strong></span>
            <span class="mr-2">Job: <strong>{{ jobs.length }}</strong></span>
            <span>Durum: <strong>{{ runningCount ? `${runningCount} çalışıyor` : 'hazır' }}</strong></span>
            <b-button
              v-if="runningCount"
              variant="outline-danger"
              size="sm"
              class="ml-auto mr-1"
              :disabled="cancellingJobIds.length > 0"
              @click="cancelRunningJobs"
            >
              <b-spinner
                v-if="cancellingJobIds.length > 0"
                small
              />
              <feather-icon
                v-else
                icon="XCircleIcon"
              />
              Testi İptal Et
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              :class="runningCount ? '' : 'ml-auto'"
              :disabled="!canRun"
              @click="onRun"
            >
              <b-spinner
                v-if="runningCount"
                small
              />
              <feather-icon
                v-else
                icon="PlayIcon"
              />
              Testi Başlat
            </b-button>
          </div>
        </b-alert>
      </b-card-body>
    </b-card>

    <b-row class="mb-2">
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric">
          <small>Motor PnL</small>
          <strong :class="aggregate.generatedPnl >= 0 ? 'text-success' : 'text-danger'">{{ signedNum(aggregate.generatedPnl, 2) }}</strong>
          <div class="text-muted font-small-3">
            Target {{ signedNum(aggregate.realizedPnl, 2) }}
          </div>
        </div>
      </b-col>
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric">
          <small>Motor Trade / WR</small>
          <strong>{{ aggregate.generatedTrades }} · {{ formatNum(aggregate.generatedWinRate, 1) }}%</strong>
          <div class="text-muted font-small-3">
            Target {{ aggregate.totalTrades }}
          </div>
        </div>
      </b-col>
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric">
          <small>Tamamlanan</small>
          <strong>{{ doneCount }}/{{ jobs.length }}</strong>
        </div>
      </b-col>
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric">
          <small>Kesilen / Açık</small>
          <strong class="text-warning">{{ aggregate.skippedFutureTrades }} / {{ aggregate.openPositionsAtEnd }}</strong>
          <div class="text-muted font-small-3">
            Açık PnL {{ signedNum(aggregate.openNetPnlAtEnd, 2) }}
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="jobs.length"
      class="mb-2"
    >
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric studio-metric--audit">
          <small>Entry Sinyal</small>
          <strong>{{ aggregate.entryAudit.rawEntrySignals }} / {{ aggregate.entryAudit.freshEntrySignals }}</strong>
          <div class="text-muted font-small-3">
            ham / fresh · sinyalsiz {{ aggregate.entryAudit.noSignalBars }}
          </div>
        </div>
      </b-col>
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric studio-metric--audit">
          <small>Entry Açılış</small>
          <strong>{{ aggregate.entryAudit.entriesOpened }} / {{ aggregate.entryAudit.exitsClosed }}</strong>
          <div class="text-muted font-small-3">
            açılan / kapanan
          </div>
        </div>
      </b-col>
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric studio-metric--audit">
          <small>Aktif Pencere</small>
          <strong>{{ aggregate.entryAudit.activeWindowBars }} / {{ aggregate.entryAudit.inactiveWindowBars }}</strong>
          <div class="text-muted font-small-3">
            aktif / pasif bar
          </div>
        </div>
      </b-col>
      <b-col
        cols="6"
        md="3"
      >
        <div class="studio-metric studio-metric--audit">
          <small>Entry Blok</small>
          <strong>{{ aggregate.entryAudit.entryRouterBlocks + aggregate.entryAudit.exposureBlocks + aggregate.entryAudit.marketConsensusBlocks }}</strong>
          <div class="text-muted font-small-3">
            router {{ aggregate.entryAudit.entryRouterBlocks }} · exposure {{ aggregate.entryAudit.exposureBlocks }} · consensus {{ aggregate.entryAudit.marketConsensusBlocks }}
          </div>
        </div>
      </b-col>
    </b-row>

    <b-alert
      v-if="targetLifecycleEvents.length"
      show
      variant="light-warning"
      class="mb-2 test-studio-lifecycle-alert"
    >
      <div class="font-weight-bolder mb-50">
        Target lifecycle sonucu
      </div>
      <div
        v-for="event in targetLifecycleEvents"
        :key="event.key"
        class="test-studio-lifecycle-line"
      >
        <b-badge
          :variant="event.variant"
          class="mr-1"
        >
          {{ event.reasonLabel }}
        </b-badge>
        <strong>{{ event.targetName }}</strong>
        <span class="text-muted">
          {{ event.completedAt ? `${formatDateTime(event.completedAt)} tarihinde durdu` : 'test sırasında lifecycle eşiğine takıldı' }}.
          Target sonucu {{ signedNum(event.acceptedPnl, 2) }} / {{ event.acceptedTrades }} trade;
          motor sonucu {{ signedNum(event.generatedPnl, 2) }} / {{ event.generatedTrades }} trade.
          <span v-if="event.skippedFutureTrades > 0">
            {{ event.skippedFutureTrades }} motor trade target sonrası kesildi.
          </span>
        </span>
      </div>
    </b-alert>

    <b-card
      v-if="jobs.length"
      no-body
      class="mb-2"
    >
      <b-card-header class="d-flex align-items-center">
        <h5 class="mb-0">
          Çalışan Hedef Durumu
        </h5>
        <b-badge
          :variant="runningCount ? 'light-warning' : 'light-success'"
          class="ml-auto"
        >
          {{ runningCount ? `${runningCount} çalışıyor` : 'tamamlandı' }}
        </b-badge>
      </b-card-header>
      <b-table
        :items="jobs"
        :fields="jobFields"
        small
        responsive
        show-empty
        empty-text="Henüz job oluşmadı."
      >
        <template #cell(targetName)="data">
          <strong>{{ data.item.targetName }}</strong>
          <div class="text-muted font-small-3">
            #{{ data.item.targetId || '-' }} · {{ data.item.id ? data.item.id.slice(0, 8) : 'local' }}
          </div>
          <div
            v-if="data.item.error"
            class="text-danger font-small-3"
          >
            {{ data.item.error }}
          </div>
        </template>
        <template #cell(status)="data">
          <b-badge :variant="statusVariant(data.item.status)">
            {{ data.item.status }}
          </b-badge>
          <div class="mt-50">
            <b-progress
              height="6px"
              :max="100"
              :value="jobProgressPercent(data.item)"
            />
            <div class="text-muted font-small-3 mt-25">
              {{ jobProgressLabel(data.item) }}
            </div>
          </div>
        </template>
        <template #cell(pnl)="data">
          <span :class="generatedSummary(data.item).realizedPnl >= 0 ? 'text-success' : 'text-danger'">
            {{ signedNum(generatedSummary(data.item).realizedPnl || 0, 2) }}
          </span>
          <div class="text-muted font-small-3">
            Target {{ signedNum(resultSummary(data.item).realizedPnl || 0, 2) }} · DD {{ formatNum(generatedSummary(data.item).maxDrawdown || 0, 2) }}
          </div>
        </template>
        <template #cell(trades)="data">
          <strong>{{ generatedSummary(data.item).totalTrades || 0 }}</strong>
          <div class="text-muted font-small-3">
            Target {{ resultSummary(data.item).totalTrades || 0 }} · Kesilen {{ resultSummary(data.item).skippedFutureTrades || 0 }} · WR {{ formatNum(generatedSummary(data.item).winRate || 0, 1) }}%
          </div>
          <div class="text-muted font-small-3">
            Sinyal {{ entryAuditSummary(data.item).rawEntrySignals || 0 }}/{{ entryAuditSummary(data.item).freshEntrySignals || 0 }} · Açılış {{ entryAuditSummary(data.item).entriesOpened || 0 }}
          </div>
        </template>
        <template #cell(range)="data">
          <div>{{ formatDateTime(data.item.startedAt || data.item.createdAt) }}</div>
          <div class="text-muted font-small-3">
            {{ formatDateTime(data.item.finishedAt || data.item.updatedAt) }}
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="isJobCancellable(data.item)"
            variant="outline-danger"
            size="sm"
            :disabled="isJobCancelling(data.item)"
            @click="cancelJob(data.item)"
          >
            <b-spinner
              v-if="isJobCancelling(data.item)"
              small
            />
            <feather-icon
              v-else
              icon="XIcon"
            />
            İptal
          </b-button>
        </template>
      </b-table>
    </b-card>

    <b-card
      no-body
      class="mb-2"
    >
      <b-card-header class="d-flex align-items-center">
        <h5 class="mb-0">
          Hedefler
        </h5>
        <b-button
          variant="outline-secondary"
          size="sm"
          class="ml-auto"
          @click="loadTargets"
        >
          <feather-icon icon="RefreshCwIcon" /> Yenile
        </b-button>
      </b-card-header>
      <b-table
        :items="targets"
        :fields="targetFields"
        small
        responsive
        show-empty
        empty-text="Hedef bulunamadı."
      >
        <template #cell(select)="data">
          <b-form-checkbox
            :checked="selectedTargetIds.includes(data.item.id)"
            @change="toggleTarget(data.item.id)"
          />
        </template>
        <template #cell(name)="data">
          <strong>{{ data.item.name }}</strong>
          <div class="text-muted font-small-3">
            {{ data.item.status }}
          </div>
        </template>
        <template #cell(goal)="data">
          {{ formatNum(data.item.profitTarget, 2) }}{{ data.item.profitTargetIsPct ? '%' : '$' }}
        </template>
        <template #cell(capital)="data">
          {{ formatNum(data.item.initialCapital, 2) }}
        </template>
      </b-table>
    </b-card>

    <b-card no-body>
      <b-card-header>
        <h5 class="mb-0">
          Karar Zaman Çizelgesi
        </h5>
      </b-card-header>
      <b-card-body class="py-1">
        <div class="d-flex flex-wrap align-items-center text-muted font-small-3">
          <span class="mr-3">Parity: <strong>{{ form.runtimeParityMode ? 'açık' : 'kapalı' }}</strong></span>
          <span class="mr-3">Guardian: <strong>{{ form.applyPositionGuardian ? 'açık' : 'kapalı' }}</strong></span>
          <span class="mr-3">Close Follow: <strong>{{ form.applyPositionGuardian && form.applyCloseFollow ? 'açık' : 'kapalı' }}</strong></span>
          <span>MFE / güvenlik: <strong>{{ form.applySafetyControls ? 'açık' : 'kapalı' }}</strong></span>
        </div>
        <div class="d-flex flex-wrap align-items-center mt-1 text-muted font-small-3">
          <b-badge
            :variant="form.runtimeParityMode ? 'info' : 'secondary'"
            class="mr-2"
          >
            {{ diffSummary.mode }}
          </b-badge>
          <span class="mr-3">Olay: <strong>{{ diffSummary.timelineEvents }}</strong></span>
          <span class="mr-3">Trade kapanışı: <strong>{{ diffSummary.tradeCloses }}</strong></span>
          <span class="mr-3">Kapanış snapshot: <strong>{{ diffSummary.closeSnapshots || closeSnapshots.length }}</strong></span>
          <span class="mr-3">Yakın takip olayı: <strong>{{ diffSummary.closeFollowEvents }}</strong></span>
          <span class="mr-3">Blok: <strong>{{ diffSummary.blocks }}</strong></span>
          <span class="mr-3">Kesilen trade: <strong>{{ aggregate.skippedFutureTrades }}</strong></span>
          <span class="mr-3">Açık pozisyon: <strong>{{ aggregate.openPositionsAtEnd }}</strong></span>
          <span>Net PnL: <strong :class="diffSummary.netPnlDelta >= 0 ? 'text-success' : 'text-danger'">{{ signedNum(diffSummary.netPnlDelta, 2) }}</strong></span>
        </div>
        <div class="mt-1 font-small-3">
          <span class="text-muted">Parity notu:</span>
          <strong class="ml-1">{{ parityNote }}</strong>
        </div>
        <b-alert
          v-if="dataCoverage && dataCoverage.reliable === false"
          show
          variant="danger"
          class="mt-1 mb-0"
        >
          Veri kapsaması eksik: {{ formatNum(dataCoverage.minCoveragePct, 2) }}% minimum. Bu test sonucu planlama için güvenilir sayılmamalı.
        </b-alert>
        <div
          v-else-if="dataCoverage && dataCoverage.requestedSeries"
          class="mt-1 text-muted font-small-3"
        >
          Veri kapsaması:
          <strong>{{ dataCoverage.completeSeries }}/{{ dataCoverage.requestedSeries }}</strong>
          seri tam · min <strong>{{ formatNum(dataCoverage.minCoveragePct, 2) }}%</strong>
        </div>
      </b-card-body>
      <b-table
        :items="decisionTimeline"
        :fields="decisionTimelineFields"
        small
        responsive
        show-empty
        empty-text="Henüz karar olayı oluşmadı."
      >
        <template #cell(status)="data">
          <b-badge :variant="timelineVariant(data.item.kind)">
            {{ data.item.kindLabel }}
          </b-badge>
          <div
            v-if="data.item.scopeLabel"
            class="text-muted font-small-3"
          >
            {{ data.item.scopeLabel }}
          </div>
          <div
            v-if="data.item.reason"
            class="text-danger font-small-3"
          >
            {{ data.item.reason }}
          </div>
        </template>
        <template #cell(pnl)="data">
          <span :class="Number(data.item.pnl || 0) >= 0 ? 'text-success' : 'text-danger'">
            {{ signedNum(data.item.pnl || 0, 2) }}
          </span>
        </template>
        <template #cell(meta)="data">
          <div>{{ data.item.metaLine }}</div>
          <div class="text-muted font-small-3">
            {{ data.item.detailLine }}
          </div>
        </template>
        <template #cell(time)="data">
          {{ formatDateTime(data.item.time) }}
        </template>
      </b-table>
    </b-card>

    <b-card
      no-body
      class="mt-2"
    >
      <b-card-header>
        <h5 class="mb-0">
          Studio / Runtime Farkı
        </h5>
      </b-card-header>
      <b-card-body class="py-1">
        <div class="mt-0 mb-1 test-studio-eligibility">
          <div class="d-flex flex-wrap align-items-start justify-content-between">
            <div>
              <strong>Entry Eligibility</strong>
              <div class="text-muted font-small-3">
                Neden pozisyon açılmadığını tek bakışta gösterir
              </div>
            </div>
            <b-badge :variant="diffSummary.tradeCloses > 0 ? 'light-success' : 'light-warning'">
              {{ eligibilityHeadline }}
            </b-badge>
          </div>
          <div class="test-studio-eligibility-grid">
            <div class="test-studio-eligibility-metric">
              <span>Aday</span>
              <strong>{{ diffSummary.timelineEvents }}</strong>
            </div>
            <div class="test-studio-eligibility-metric">
              <span>Eligible</span>
              <strong>{{ diffSummary.tradeCloses }}</strong>
            </div>
            <div class="test-studio-eligibility-metric">
              <span>Blocked</span>
              <strong>{{ diffSummary.blocks }}</strong>
            </div>
            <div class="test-studio-eligibility-metric">
              <span>Opened</span>
              <strong>{{ diffSummary.tradeCloses }}</strong>
            </div>
          </div>
          <div
            v-if="topDecisionReason"
            class="text-muted font-small-3 mt-50"
          >
            En baskın sebep: <strong>{{ topDecisionReason }}</strong>
          </div>
        </div>

        <div class="d-flex flex-wrap align-items-center text-muted font-small-3">
          <b-badge
            :variant="diffSummary.blocks ? 'warning' : 'success'"
            class="mr-2"
          >
            {{ runtimeDiffLabel }}
          </b-badge>
          <span class="mr-3">Mod: <strong>{{ form.runtimeParityMode ? 'parity' : 'studio' }}</strong></span>
          <span class="mr-3">Kapanış: <strong>{{ diffSummary.tradeCloses }}</strong></span>
          <span class="mr-3">Blok: <strong>{{ diffSummary.blocks }}</strong></span>
          <span>Okuma: <strong :class="diffSummary.blocks ? 'text-warning' : 'text-success'">{{ runtimeDiffLabel }}</strong></span>
        </div>
        <div class="mt-1 text-muted font-small-3">
          Guardrail:
          <strong class="ml-1">S {{ getGuardrailFlag(diffSummary.guardrailSnapshot.safety) }}</strong>,
          <strong class="ml-1">G {{ getGuardrailFlag(diffSummary.guardrailSnapshot.guardian) }}</strong>,
          <strong class="ml-1">R {{ getGuardrailFlag(diffSummary.guardrailSnapshot.recovery) }}</strong>,
          <strong class="ml-1">CF {{ getGuardrailFlag(diffSummary.guardrailSnapshot.closeFollow) }}</strong>,
          <strong class="ml-1">ER {{ getGuardrailFlag(diffSummary.guardrailSnapshot.entryRouter) }}</strong>
        </div>
        <div class="mt-1 text-muted font-small-3">
          <span class="mr-2">Stage: <strong>{{ diffSummary.stage }}</strong></span>
          <span class="mr-2">Kind: <strong>{{ diffSummary.decisionKind }}</strong></span>
          <span>Reason: <strong>{{ diffSummary.reason }}</strong></span>
        </div>
        <div class="mt-1 text-muted font-small-3">
          Modül dağılımı:
          <span
            v-for="row in moduleSplitRows"
            :key="row.key"
            class="mr-2"
          >
            <strong>{{ row.label }} {{ row.value }}</strong>
          </span>
        </div>
        <div class="mt-1 font-small-3 text-muted">
          {{ diffSummary.note }}
        </div>
      </b-card-body>
    </b-card>

    <b-card
      no-body
      class="mt-2"
    >
      <b-card-header>
        <h5 class="mb-0">
          Kapanış Snapshotları
        </h5>
      </b-card-header>
      <b-table
        :items="closeSnapshots"
        :fields="closeSnapshotFields"
        small
        responsive
        show-empty
        empty-text="Kapanış snapshot oluşmadı."
      >
        <template #cell(time)="data">
          {{ formatDateTime(data.item.time) }}
          <div class="text-muted font-small-3">
            {{ data.item.targetName }}
          </div>
        </template>
        <template #cell(asset)="data">
          <strong>{{ data.item.symbol }}</strong>
          <div class="text-muted font-small-3">
            #{{ data.item.botId }} · {{ data.item.timeframe }}
          </div>
        </template>
        <template #cell(module)="data">
          <b-badge :variant="decisionModuleVariant(data.item.decisionModule)">
            {{ data.item.decisionModule }}
          </b-badge>
          <div class="text-muted font-small-3">
            {{ data.item.decisionKind }}
          </div>
        </template>
        <template #cell(mfe)="data">
          <span class="text-success">{{ signedNum(data.item.mfe || 0, 2) }}</span>
        </template>
        <template #cell(mae)="data">
          <span class="text-danger">{{ signedNum(data.item.mae || 0, 2) }}</span>
        </template>
        <template #cell(pnl)="data">
          <span :class="Number(data.item.pnl || 0) >= 0 ? 'text-success' : 'text-danger'">
            {{ signedNum(data.item.pnl || 0, 2) }}
          </span>
        </template>
        <template #cell(reason)="data">
          <div>{{ data.item.reason }}</div>
          <div class="text-muted font-small-3">
            {{ data.item.toggleSnapshot && data.item.toggleSnapshot.safetyGovernor ? 'safety governor' : 'studio / toggle' }}
          </div>
        </template>
      </b-table>
    </b-card>

    <b-card
      no-body
      class="mt-2"
    >
      <b-card-header>
        <h5 class="mb-0">
          Yakın Takip Zaman Çizelgesi
        </h5>
      </b-card-header>
      <b-table
        :items="closeFollowEvents"
        :fields="closeFollowEventFields"
        small
        responsive
        show-empty
        empty-text="Yakın Takip olayı oluşmadı."
      >
        <template #cell(time)="data">
          {{ formatDateTime(data.item.time) }}
        </template>
        <template #cell(action)="data">
          <b-badge :variant="closeFollowActionVariant(data.item.action)">
            {{ closeFollowActionLabel(data.item.action) }}
          </b-badge>
          <div class="text-muted font-small-3">
            {{ data.item.targetName }}
          </div>
        </template>
        <template #cell(position)="data">
          <strong>{{ data.item.symbol || '-' }}</strong>
          <div class="text-muted font-small-3">
            Bot #{{ data.item.botId || '-' }}
          </div>
        </template>
        <template #cell(pnl)="data">
          <span :class="Number(data.item.pnl || 0) >= 0 ? 'text-success' : 'text-danger'">
            {{ signedNum(data.item.pnl || 0, 2) }}
          </span>
          <div class="text-muted font-small-3">
            Açık {{ signedNum(data.item.openNetPnl || 0, 2) }}
          </div>
        </template>
        <template #cell(buffer)="data">
          Tampon {{ formatNum(data.item.safeProfitBuffer, 2) }}
          <div class="text-muted font-small-3">
            Kullanım {{ formatNum(data.item.lossUsagePct, 0) }}%
          </div>
        </template>
      </b-table>
    </b-card>

    <b-modal
      id="test-mode-help-modal"
      title="Test Modları"
      ok-only
      ok-title="Tamam"
      centered
      size="lg"
    >
      <div class="test-mode-help">
        <div class="mb-2">
          <h6 class="mb-50">
            Mevcut botlarla test
          </h6>
          <p class="mb-0 text-muted">
            Test dünyası seçilen tarihte başlar ve hedefte bağlı olan botlarla yürür. Bot oluşturmaz; ama entry,
            exit, guardrail, exposure ve yakın takip akışı sanal runtime timeline üzerinde çalışır.
          </p>
        </div>

        <div class="mb-2">
          <h6 class="mb-50">
            Sistemi baştan kur
          </h6>
          <p class="mb-0 text-muted">
            Test dünyası seçilen tarihte sıfırdan kurulur. Auto selector açıksa test zamanında elde olan geçmiş
            veriye göre indikatör/havuz seçilir; sanal rescan aralığı geldikçe bot havuzu yeniden kurulur ve
            sonraki mumlarda o havuz entry alır. Rescan süresi aralığı aşarsa, yeni rescan bitişten sonraki ilk
            grid slotunda başlar.
          </p>
        </div>

        <b-alert
          show
          variant="light-primary"
          class="mb-0"
        >
          Tüm test modları sanal runtime timeline üzerinde çalışır. Mod seçimi yalnızca başlangıç bot havuzunu
          belirler.
        </b-alert>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCard, BCardBody, BCardHeader, BCol, BModal,
  BFormCheckbox, BFormInput, BFormSelect, BProgress, BRow, BSpinner, BTable,
} from 'bootstrap-vue'

export default {
  name: 'TestStudioIndex',
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCol,
    BModal,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    BProgress,
    BRow,
    BSpinner,
    BTable,
  },
  data() {
    const today = new Date()
    const start = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
    return {
      form: {
        startAt: this.toDateInput(start),
        endAt: this.toDateInput(today),
        testMode: 'EXISTING_BOTS',
        dataMode: 'PROVIDER',
        providerKind: 'BINANCE',
        coinLimit: 20,
        candleLimit: 1500,
        applySafetyControls: true,
        applyPositionGuardian: true,
        applyCloseFollow: true,
        runtimeParityMode: true,
        useRuntimeIndicatorSelection: true,
        useRuntimeIndicatorPool: true,
        virtualRescanIntervalMinutes: 5,
        virtualRescanDurationMinutes: 0,
        botCount: 10,
        market: 'FUTURES',
        edgeKind: 'QUICK_GAIN',
        timeframesRaw: '5m,15m',
        tpPerc: 1.2,
        slPerc: 0.8,
        leverage: 30,
        commissionPerSide: 0.05,
        randomSeed: 'test-studio',
        randomVolatility: 0.8,
      },
      selectedTargetIds: [],
      jobs: [],
      cancellingJobIds: [],
      pollTimer: null,
      decisionTimelineFields: [
        { key: 'time', label: 'Zaman' },
        { key: 'status', label: 'Olay' },
        { key: 'meta', label: 'Detay' },
        { key: 'pnl', label: 'PnL' },
      ],
      targetFields: [
        { key: 'select', label: '', thClass: 'width-50' },
        { key: 'name', label: 'Hedef' },
        { key: 'capital', label: 'Sermaye' },
        { key: 'goal', label: 'Kâr hedefi' },
        { key: 'createdAt', label: 'Oluşturma' },
      ],
      jobFields: [
        { key: 'targetName', label: 'Hedef' },
        { key: 'status', label: 'Durum' },
        { key: 'pnl', label: 'PnL' },
        { key: 'trades', label: 'Trade / WR' },
        { key: 'range', label: 'Aralık' },
        { key: 'actions', label: '' },
      ],
      closeFollowEventFields: [
        { key: 'time', label: 'Zaman' },
        { key: 'action', label: 'Aksiyon' },
        { key: 'position', label: 'Pozisyon' },
        { key: 'pnl', label: 'PnL' },
        { key: 'buffer', label: 'Tampon' },
        { key: 'reason', label: 'Sebep' },
      ],
      closeSnapshotFields: [
        { key: 'time', label: 'Zaman' },
        { key: 'asset', label: 'Varlık' },
        { key: 'module', label: 'Modül' },
        { key: 'mfe', label: 'MFE' },
        { key: 'mae', label: 'MAE' },
        { key: 'pnl', label: 'PnL' },
        { key: 'reason', label: 'Sebep' },
      ],
      testModeOptions: [
        { value: 'EXISTING_BOTS', text: 'Mevcut botlarla test' },
        { value: 'REBUILD_FROM_EDGES', text: 'Sistemi baştan kur' },
      ],
      dataModeOptions: [
        { value: 'PROVIDER', text: 'Provider datası' },
        { value: 'RANDOM', text: 'Random mum datası' },
      ],
      marketOptions: [
        { value: 'FUTURES', text: 'Futures' },
        { value: 'SPOT', text: 'Spot' },
      ],
      edgeKindOptions: [
        { value: 'NORMAL', text: 'Normal' },
        { value: 'QUICK_GAIN', text: 'Quick Gain' },
      ],
      providerOptions: [
        { value: 'BINANCE', text: 'Binance' },
        { value: 'BINANCE_TESTNET', text: 'Binance Testnet' },
        { value: 'SIMULATED', text: 'Simulated' },
      ],
    }
  },
  computed: {
    targets() { return this.$store.getters['targets/dataList'] || [] },
    canRun() { return this.selectedTargetIds.length > 0 && this.form.startAt && this.form.endAt && !this.runningCount },
    usesRebuildLikeMode() { return this.form.testMode === 'REBUILD_FROM_EDGES' },
    providerLimitWarning() {
      if (this.form.dataMode !== 'PROVIDER') return ''
      const coinCount = Math.max(1, Number(this.form.coinLimit || 1))
      const timeframeCount = Math.max(1, this.form.timeframesRaw.split(',').map(v => v.trim()).filter(Boolean).length || 1)
      const startMs = this.form.startAt ? new Date(this.form.startAt).getTime() : 0
      const endMs = this.form.endAt ? new Date(this.form.endAt).getTime() : 0
      const rangeMs = Math.max(0, endMs - startMs)
      const rescanIntervalMinutes = Math.max(1, Math.min(10080, Number(this.form.virtualRescanIntervalMinutes || 5)))
      const rescanWindowMs = rescanIntervalMinutes * 60 * 1000
      const rescanPoints = this.usesRebuildLikeMode
        ? Math.max(1, Math.min(24, Math.floor(rangeMs / rescanWindowMs) + 1))
        : 1
      const rebuildMultiplier = rescanPoints
      const estimatedRequests = coinCount * timeframeCount * rebuildMultiplier
      if (estimatedRequests >= 300) {
        return `Bu kurulum yaklaşık ${estimatedRequests} mum isteği üretebilir (${rescanPoints} sanal rescan checkpoint). Test yavaşlatılarak çalışır; mümkünse coin/timeframe azalt.`
      }
      if (estimatedRequests >= 120) {
        return 'Bu kurulum orta-yüksek provider yükü oluşturur. Rate limit olursa sistem bekleyip tekrar dener.'
      }
      return ''
    },
    runningCount() { return this.jobs.filter(j => j.status === 'QUEUED' || j.status === 'RUNNING').length },
    doneCount() { return this.jobs.filter(j => j.status === 'DONE').length },
    aggregate() {
      const results = this.jobs.map(j => j.result).filter(result => result && result.summary)
      const realizedPnl = results.reduce((sum, r) => sum + Number(r.summary.realizedPnl || 0), 0)
      const totalTrades = results.reduce((sum, r) => sum + Number(r.summary.totalTrades || 0), 0)
      const wins = results.reduce((sum, r) => sum + Number(r.summary.wins || 0), 0)
      const maxDrawdown = results.reduce((max, r) => Math.max(max, Number(r.summary.maxDrawdown || 0)), 0)
      const generatedPnl = results.reduce((sum, r) => sum + Number(r.summary.generated?.realizedPnl ?? r.summary.realizedPnl ?? 0), 0)
      const generatedTrades = results.reduce((sum, r) => sum + Number(r.summary.generated?.totalTrades ?? r.summary.totalTrades ?? 0), 0)
      const generatedWins = results.reduce((sum, r) => sum + Number(r.summary.generated?.wins ?? r.summary.wins ?? 0), 0)
      const generatedMaxDrawdown = results.reduce((max, r) => Math.max(max, Number(r.summary.generated?.maxDrawdown ?? r.summary.maxDrawdown ?? 0)), 0)
      const skippedFutureTrades = results.reduce((sum, r) => sum + Number(r.summary.skippedFutureTrades || 0), 0)
      const openPositionsAtEnd = results.reduce((sum, r) => sum + Number(r.summary.openPositionsAtEnd || 0), 0)
      const openNetPnlAtEnd = results.reduce((sum, r) => sum + Number(r.summary.openNetPnlAtEnd || 0), 0)
      const entryAudit = this.sumEntryAudit(results.map(r => r.summary.entryAudit || {}))
      return {
        realizedPnl,
        totalTrades,
        winRate: totalTrades ? (wins / totalTrades) * 100 : 0,
        maxDrawdown,
        generatedPnl,
        generatedTrades,
        generatedWinRate: generatedTrades ? (generatedWins / generatedTrades) * 100 : 0,
        generatedMaxDrawdown,
        skippedFutureTrades,
        openPositionsAtEnd,
        openNetPnlAtEnd,
        entryAudit,
      }
    },
    decisionTimeline() {
      return this.jobs.flatMap(job => {
        const tradeTimeline = (job.result?.timeline || []).map(trade => ({
          kind: 'TRADE_CLOSE',
          kindLabel: 'Trade kapandı',
          scopeLabel: job.targetName,
          time: trade.exitTime,
          pnl: trade.pnl,
          metaLine: `${trade.symbol} · ${trade.timeframe} · ${trade.reason}`,
          detailLine: `Giriş ${this.formatDateTime(trade.entryTime)} · Çıkış ${this.formatDateTime(trade.exitTime)}`,
          reason: trade.reason,
        }))
        const closeFollowTimeline = (job.result?.closeFollowTimeline || []).map(event => {
          let kind = 'CLOSE_FOLLOW'
          if (event.action === 'ENTRY_BLOCKED') kind = 'ENTRY_BLOCKED'
          if (event.action === 'RECOVERY_BLOCKED') kind = 'RECOVERY_BLOCKED'
          return {
            kind,
            kindLabel: this.closeFollowActionLabel(event.action),
            scopeLabel: job.targetName,
            time: event.time,
            pnl: event.realizedPnl ?? event.pnl ?? 0,
            metaLine: `${event.symbol || '-'} · buffer ${this.formatNum(event.safeProfitBuffer, 2)} · kullanım ${this.formatNum(event.lossUsagePct, 0)}%`,
            detailLine: event.reason,
            reason: event.reason,
          }
        })
        return [...tradeTimeline, ...closeFollowTimeline]
      })
        .sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime())
        .slice(-300)
        .reverse()
    },
    closeSnapshots() {
      return this.jobs
        .flatMap(job => (job.result?.closeSnapshots || []).map(snapshot => ({
          ...snapshot,
          targetName: job.targetName,
        })))
        .sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime())
        .slice(-300)
        .reverse()
    },
    diffSummary() {
      const result = this.jobs.find(job => job.result?.summary?.diffSummary)?.result?.summary?.diffSummary
      return result || {
        mode: this.form.runtimeParityMode ? 'PARITY' : 'STUDIO',
        timelineEvents: this.timelineSummary.total,
        tradeCloses: this.timelineSummary.tradeCloses,
        closeSnapshots: this.closeSnapshots.length,
        closeFollowEvents: this.timelineSummary.closeFollowEvents,
        blocks: this.timelineSummary.blocks,
        guardrailSnapshot: {
          safety: this.form.applySafetyControls,
          guardian: this.form.applyPositionGuardian,
          recovery: this.form.runtimeParityMode,
          closeFollow: this.form.applyPositionGuardian && this.form.applyCloseFollow,
          entryRouter: this.form.runtimeParityMode,
        },
        stage: this.form.runtimeParityMode ? 'PARITY' : 'STUDIO',
        decisionKind: this.form.runtimeParityMode ? 'LIVE_LIKE_SIMULATION' : 'STUDIO_BASELINE',
        reason: this.parityNote,
        moduleSplit: {
          guardian: this.timelineSummary.blocks,
          closeFollow: this.timelineSummary.closeFollowEvents,
          entryRouter: 0,
          exposure: 0,
          marketConsensus: 0,
          opportunityFallback: 0,
        },
        netPnlDelta: this.timelineSummary.netPnl,
        note: this.parityNote,
      }
    },
    dataCoverage() {
      return this.jobs.find(job => job.result?.summary?.dataCoverage)?.result?.summary?.dataCoverage || null
    },
    targetLifecycleEvents() {
      return this.jobs
        .filter(job => job.result?.summary)
        .map(job => {
          const { summary } = job.result
          const generated = summary.generated || summary
          const accepted = summary.accepted || summary
          const skippedFutureTrades = Number(summary.skippedFutureTrades || 0)
          const reason = summary.reason || null
          if (!reason && skippedFutureTrades <= 0) return null
          return {
            key: `${job.id || job.targetId}-${reason || 'lifecycle'}`,
            targetName: job.targetName,
            reason,
            reasonLabel: this.lifecycleReasonLabel(reason),
            variant: this.lifecycleReasonVariant(reason),
            completedAt: summary.completedAt || null,
            acceptedPnl: Number(accepted.realizedPnl ?? summary.realizedPnl ?? 0),
            acceptedTrades: Number(accepted.totalTrades ?? summary.totalTrades ?? 0),
            generatedPnl: Number(generated.realizedPnl ?? summary.realizedPnl ?? 0),
            generatedTrades: Number(generated.totalTrades ?? summary.totalTrades ?? 0),
            skippedFutureTrades,
          }
        })
        .filter(Boolean)
    },
    moduleSplitRows() {
      const split = this.diffSummary.moduleSplit || {}
      const rows = [
        { key: 'guardian', label: 'Guardian', value: Number(split.guardian || 0) },
        { key: 'closeFollow', label: 'Close Follow', value: Number(split.closeFollow || 0) },
        { key: 'entryRouter', label: 'Entry Router', value: Number(split.entryRouter || 0) },
        { key: 'exposure', label: 'Exposure/Dedupe', value: Number(split.exposure || 0) },
        { key: 'marketConsensus', label: 'Market Consensus', value: Number(split.marketConsensus || 0) },
        { key: 'opportunityFallback', label: 'Opportunity Fallback', value: Number(split.opportunityFallback || 0) },
      ]
      const active = rows.filter(row => row.value > 0)
      return active.length ? active : rows.slice(0, 3)
    },
    timelineSummary() {
      const rows = this.decisionTimeline
      return {
        total: rows.length,
        tradeCloses: rows.filter(row => row.kind === 'TRADE_CLOSE').length,
        closeFollowEvents: rows.filter(row => row.kind === 'CLOSE_FOLLOW').length,
        blocks: rows.filter(row => row.kind === 'ENTRY_BLOCKED' || row.kind === 'RECOVERY_BLOCKED').length,
        netPnl: rows.reduce((sum, row) => sum + Number(row.pnl || 0), 0),
      }
    },
    parityNote() {
      if (!this.form.runtimeParityMode) return 'Studio modu açık; runtime güvenlikleri birebir simule edilmiyor.'
      if (!this.timelineSummary.total) return 'Parity açık; olay bekleniyor.'
      if (this.timelineSummary.blocks > 0) return 'Parity açık; blok ve kapanış akışı canlıya yakın okunuyor.'
      return 'Parity açık; akış sakin görünüyor, fark sinyali düşük.'
    },
    runtimeDiffLabel() {
      if (!this.form.runtimeParityMode) return 'fark beklenir'
      if (this.diffSummary.blocks > 0) return 'kontrol gerekli'
      return 'düşük fark'
    },
    eligibilityHeadline() {
      const candidates = Number(this.timelineSummary.total || 0)
      const opened = Number(this.diffSummary.tradeCloses || 0)
      if (!candidates) return 'Veri bekleniyor'
      if (opened === 0) return 'Hiç pozisyon açılmadı'
      return `${opened}/${candidates} açıldı`
    },
    topDecisionReason() {
      const blocked = (this.decisionTimeline || []).find(row => row.kind === 'ENTRY_BLOCKED' || row.kind === 'RECOVERY_BLOCKED')
      if (blocked) {
        const module = blocked.kind === 'RECOVERY_BLOCKED' ? 'EXIT_GOVERNOR' : 'ENTRY_ROUTER'
        return `${module}: ${blocked.reason}`
      }
      const top = this.moduleSplitRows.find(row => row.value > 0)
      if (!top) return ''
      return `${top.label}: ${top.value} karar`
    },
    closeFollowEvents() {
      return this.jobs
        .flatMap(job => (job.result?.closeFollowTimeline || []).map(event => ({
          ...event,
          targetName: job.targetName,
        })))
        .sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime())
        .slice(-300)
    },
  },
  created() {
    this.loadTargets()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    async loadTargets() {
      await this.$store.dispatch('targets/getDataList', { limit: 200 })
      if (!this.selectedTargetIds.length && this.targets.length) {
        this.selectedTargetIds = this.targets.slice(0, 3).map(t => t.id)
      }
    },
    getGuardrailFlag(value) {
      return value ? 'Açık' : 'Kapalı'
    },
    toggleTarget(id) {
      if (this.selectedTargetIds.includes(id)) {
        this.selectedTargetIds = this.selectedTargetIds.filter(item => item !== id)
      } else {
        this.selectedTargetIds = [...this.selectedTargetIds, id]
      }
    },
    async onRun() {
      this.stopPolling()
      this.jobs = []
      this.cancellingJobIds = []
      const body = this.buildBody()
      const selectedTargets = this.targets.filter(t => this.selectedTargetIds.includes(t.id))
      this.jobs = selectedTargets.map(target => ({
        targetId: target.id,
        targetName: target.name,
        status: 'QUEUED',
        result: {
          progress: {
            percent: 0,
            stage: 'başlatılıyor',
          },
        },
      }))
      this.jobs = await Promise.all(selectedTargets.map(async target => {
        try {
          const job = await this.$store.dispatch('targets/backtest', { id: target.id, body })
          return { ...job, targetName: target.name }
        } catch (err) {
          const message = err?.response?.data?.message || err.message || 'Test başlatılamadı.'
          return {
            targetId: target.id, targetName: target.name, status: 'FAILED', error: message, result: null,
          }
        }
      }))
      this.startPolling()
    },
    isJobCancellable(job) {
      return Boolean(job && job.id && (job.status === 'QUEUED' || job.status === 'RUNNING'))
    },
    isJobCancelling(job) {
      return Boolean(job && job.id && this.cancellingJobIds.includes(job.id))
    },
    async cancelJob(job) {
      if (!this.isJobCancellable(job) || this.isJobCancelling(job)) return
      this.cancellingJobIds = [...this.cancellingJobIds, job.id]
      try {
        const cancelled = await this.$store.dispatch('targets/cancelBacktestJob', { id: job.targetId, jobId: job.id })
        this.jobs = this.jobs.map(item => (item.id === job.id
          ? this.mergeBacktestJob(item, { ...cancelled, targetName: item.targetName })
          : item))
      } catch (err) {
        const message = err?.response?.data?.message || 'Job iptal edilemedi.'
        this.jobs = this.jobs.map(item => (item.id === job.id ? { ...item, error: message } : item))
      } finally {
        this.cancellingJobIds = this.cancellingJobIds.filter(id => id !== job.id)
        if (this.runningCount && !this.pollTimer) this.startPolling()
      }
    },
    async cancelRunningJobs() {
      const cancellable = this.jobs.filter(job => this.isJobCancellable(job))
      await Promise.all(cancellable.map(job => this.cancelJob(job)))
    },
    buildBody() {
      const timeframes = this.parseCsv(this.form.timeframesRaw).map(item => item.toLowerCase())
      return {
        providerKind: this.form.providerKind,
        candleLimit: this.form.candleLimit,
        startAt: this.dateToIso(this.form.startAt, false),
        endAt: this.dateToIso(this.form.endAt, true),
        dataMode: this.form.dataMode,
        testMode: this.form.testMode,
        applySafetyControls: this.form.applySafetyControls,
        applyPositionGuardian: this.form.applyPositionGuardian,
        applyCloseFollow: this.form.applyPositionGuardian && this.form.applyCloseFollow,
        runtimeParityMode: this.form.runtimeParityMode,
        toggleSnapshot: {
          guardian: this.form.applyPositionGuardian,
          recovery: this.form.runtimeParityMode,
          closeFollow: this.form.applyPositionGuardian && this.form.applyCloseFollow,
          entryRouter: this.form.runtimeParityMode,
          safetyGovernor: this.form.applySafetyControls,
        },
        guardrailSnapshot: {
          safety: this.form.applySafetyControls,
          guardian: this.form.applyPositionGuardian,
          recovery: this.form.runtimeParityMode,
          closeFollow: this.form.applyPositionGuardian && this.form.applyCloseFollow,
          entryRouter: this.form.runtimeParityMode,
        },
        decisionSnapshot: {
          stage: this.form.runtimeParityMode ? 'PARITY' : 'STUDIO',
          decisionKind: this.form.runtimeParityMode ? 'LIVE_LIKE_SIMULATION' : 'STUDIO_BASELINE',
          reason: this.parityNote,
        },
        coinLimit: this.form.coinLimit,
        useRuntimeIndicatorSelection: this.form.testMode === 'REBUILD_FROM_EDGES' ? this.form.useRuntimeIndicatorSelection : undefined,
        useRuntimeIndicatorPool: this.form.testMode === 'REBUILD_FROM_EDGES' ? this.form.useRuntimeIndicatorPool : undefined,
        virtualRescanIntervalMinutes: this.form.testMode === 'REBUILD_FROM_EDGES' ? this.form.virtualRescanIntervalMinutes : undefined,
        virtualRescanDurationMinutes: this.form.testMode === 'REBUILD_FROM_EDGES' ? this.form.virtualRescanDurationMinutes : undefined,
        botCount: this.usesRebuildLikeMode ? this.form.botCount : undefined,
        market: this.form.market,
        edgeKind: this.form.edgeKind,
        timeframes: timeframes.length ? timeframes : undefined,
        tpPerc: this.usesRebuildLikeMode ? this.form.tpPerc : undefined,
        slPerc: this.usesRebuildLikeMode ? this.form.slPerc : undefined,
        leverage: this.usesRebuildLikeMode ? this.form.leverage : undefined,
        commissionPerSide: this.usesRebuildLikeMode ? this.form.commissionPerSide : undefined,
        entryPresetDraft: this.form.runtimeParityMode ? this.entryRouterPresetDraftOverride() : undefined,
        randomSeed: this.form.randomSeed,
        randomVolatility: this.form.randomVolatility,
      }
    },
    entryRouterPresetDraftOverride() {
      try {
        const raw = window.localStorage.getItem('traderio.entryRouter.entryPresetDraft')
        if (!raw) return undefined
        const parsed = JSON.parse(raw)
        if (!parsed || parsed.autoApplyEnabled !== true || !parsed.draft || typeof parsed.draft !== 'object') return undefined
        const draft = parsed.draft
        const hasSignalEntry = draft.signalEntry && typeof draft.signalEntry === 'object'
        const hasIndicatorParams = draft.indicatorParams && typeof draft.indicatorParams === 'object'
        const hasPositionManagement = draft.positionManagement && typeof draft.positionManagement === 'object'
        if (!hasSignalEntry && !hasIndicatorParams && !hasPositionManagement) return undefined
        return {
          autoApplyEnabled: true,
          signalEntry: hasSignalEntry ? draft.signalEntry : undefined,
          indicatorParams: hasIndicatorParams ? draft.indicatorParams : undefined,
          positionManagement: hasPositionManagement ? draft.positionManagement : undefined,
          source: 'ENTRY_ROUTER_AUTO_DRAFT',
          updatedAt: parsed.updatedAt || null,
        }
      } catch (e) {
        return undefined
      }
    },
    parseCsv(value) {
      if (!value) return []
      return value.split(',').map(item => item.trim()).filter(Boolean)
    },
    startPolling() {
      if (!this.runningCount) return
      if (this.pollTimer) return
      const tick = async () => {
        const nextJobs = await Promise.all(this.jobs.map(async job => {
          if (!job.id || (job.status !== 'QUEUED' && job.status !== 'RUNNING')) {
            return job
          }
          try {
            const fresh = await this.$store.dispatch('targets/getBacktestJob', { id: job.targetId, jobId: job.id })
            return this.mergeBacktestJob(job, { ...fresh, targetName: job.targetName })
          } catch (err) {
            const message = err?.response?.data?.message || 'Job durumu alınamadı.'
            return { ...job, status: 'FAILED', error: message }
          }
        }))
        this.jobs = nextJobs
        if (this.runningCount) this.pollTimer = setTimeout(tick, 2500)
      }
      this.pollTimer = setTimeout(tick, 1000)
    },
    stopPolling() {
      if (!this.pollTimer) return
      clearTimeout(this.pollTimer)
      this.pollTimer = null
    },
    resultSummary(job) {
      return job.result?.summary || {
        realizedPnl: 0, totalTrades: 0, winRate: 0, skippedFutureTrades: 0,
      }
    },
    generatedSummary(job) {
      const summary = this.resultSummary(job)
      return summary.generated || summary
    },
    zeroEntryAudit() {
      return {
        scannedBars: 0,
        activeWindowBars: 0,
        inactiveWindowBars: 0,
        noSignalBars: 0,
        rawEntrySignals: 0,
        freshEntrySignals: 0,
        staleSignalBlocks: 0,
        duplicateSignalBlocks: 0,
        signalAgeBlocks: 0,
        confirmationWaits: 0,
        priceEntryBlocks: 0,
        guardEntryBlocks: 0,
        entryRouterBlocks: 0,
        exposureBlocks: 0,
        marketConsensusBlocks: 0,
        opportunityBlocks: 0,
        entriesOpened: 0,
        exitsClosed: 0,
      }
    },
    sumEntryAudit(items) {
      const totals = this.zeroEntryAudit()
      items.forEach(item => {
        Object.keys(totals).forEach(key => {
          totals[key] += Number(item?.[key] || 0)
        })
      })
      return totals
    },
    entryAuditSummary(job) {
      return this.resultSummary(job).entryAudit || this.zeroEntryAudit()
    },
    mergeBacktestJob(current, fresh) {
      const currentResult = current.result || null
      const freshResult = fresh.result || null
      if (!currentResult || !freshResult) return fresh
      if (currentResult.summary && !freshResult.summary) {
        return {
          ...fresh,
          result: {
            ...currentResult,
            ...freshResult,
            progress: freshResult.progress || currentResult.progress,
          },
        }
      }
      const currentTrades = Number(currentResult.summary?.totalTrades ?? 0)
      const freshTrades = Number(freshResult.summary?.totalTrades ?? 0)
      if (fresh.status !== 'DONE' && currentTrades > freshTrades) {
        return {
          ...fresh,
          result: {
            ...freshResult,
            summary: currentResult.summary,
            botResults: currentResult.botResults || freshResult.botResults,
            timeline: currentResult.timeline || freshResult.timeline,
            closeSnapshots: currentResult.closeSnapshots || freshResult.closeSnapshots,
            closeFollowTimeline: currentResult.closeFollowTimeline || freshResult.closeFollowTimeline,
          },
        }
      }
      return fresh
    },
    guardianConfig(job) {
      return job.result?.config?.positionGuardian || null
    },
    hasGuardianStats(job) {
      const summary = this.resultSummary(job)
      return Boolean(summary.guardianCloses || summary.guardianSoftExits || summary.guardianStopHits)
    },
    hasCloseFollowStats(job) {
      const summary = this.resultSummary(job)
      return Boolean(
        summary.closeFollowCloses
        || summary.closeFollowProtectedExits
        || summary.closeFollowEntryBlocks
        || summary.closeFollowPnlDelta,
      )
    },
    closeFollowActionVariant(action) {
      if (action === 'CLOSE_LOSER') return 'danger'
      if (action === 'PROTECT_WINNER') return 'success'
      return 'warning'
    },
    closeFollowActionLabel(action) {
      const labels = {
        ENTRY_BLOCKED: 'Giriş durdu',
        RECOVERY_BLOCKED: 'Recovery durdu',
        PROTECT_WINNER: 'Kâr kilitlendi',
        CLOSE_LOSER: 'Zarar kapandı',
      }
      return labels[action] || action
    },
    timelineVariant(kind) {
      if (kind === 'TRADE_CLOSE') return 'success'
      if (kind === 'RECOVERY_BLOCKED' || kind === 'ENTRY_BLOCKED') return 'warning'
      return 'info'
    },
    lifecycleReasonLabel(reason) {
      if (reason === 'profit_hit') return 'profit hit'
      if (reason === 'loss_hit') return 'loss hit'
      return 'lifecycle'
    },
    lifecycleReasonVariant(reason) {
      if (reason === 'profit_hit') return 'light-success'
      if (reason === 'loss_hit') return 'light-danger'
      return 'light-warning'
    },
    jobProgress(job) {
      return job.result && job.result.progress ? job.result.progress : null
    },
    jobProgressPercent(job) {
      const progress = this.jobProgress(job)
      if (!progress) return job.status === 'DONE' ? 100 : 0
      const direct = Number(progress.percent ?? progress.percentage ?? progress.progressPct ?? progress.pct)
      if (Number.isFinite(direct)) return Math.max(0, Math.min(100, direct))
      const current = Number(progress.current ?? progress.processed ?? progress.done ?? progress.completed ?? progress.index)
      const total = Number(progress.total ?? progress.count ?? progress.totalBars ?? progress.totalCandles)
      if (Number.isFinite(current) && Number.isFinite(total) && total > 0) {
        return Math.max(0, Math.min(100, (current / total) * 100))
      }
      return job.status === 'DONE' ? 100 : 0
    },
    jobProgressLabel(job) {
      const progress = this.jobProgress(job)
      const percent = this.jobProgressPercent(job)
      if (!progress) return `${this.formatNum(percent, 0)}%`
      const current = progress.current ?? progress.processed ?? progress.done ?? progress.completed ?? progress.index
      const total = progress.total ?? progress.count ?? progress.totalBars ?? progress.totalCandles
      const stage = progress.stage || progress.label || progress.message || ''
      const countText = current !== undefined && total !== undefined ? ` · ${current}/${total}` : ''
      return `${this.formatNum(percent, 0)}%${countText}${stage ? ` · ${stage}` : ''}`
    },
    statusVariant(status) {
      if (status === 'DONE') return 'success'
      if (status === 'FAILED') return 'danger'
      if (status === 'CANCELLED') return 'secondary'
      if (status === 'RUNNING') return 'warning'
      return 'secondary'
    },
    dateToIso(value, endOfDay) {
      if (!value) return null
      const suffix = endOfDay ? 'T23:59:59' : 'T00:00:00'
      return new Date(`${value}${suffix}`).toISOString()
    },
    toDateInput(date) {
      return date.toISOString().slice(0, 10)
    },
    formatNum(v, d = 2) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '—'
      return n.toFixed(d)
    },
    signedNum(v, d = 2) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '—'
      return `${n >= 0 ? '+' : ''}${n.toFixed(d)}`
    },
    formatDateTime(v) {
      if (!v) return '—'
      const d = new Date(v)
      if (Number.isNaN(d.getTime())) return String(v)
      return d.toLocaleString('tr-TR', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
      })
    },
    decisionModuleVariant(module) {
      if (module === 'GUARDIAN') return 'danger'
      if (module === 'CLOSE_FOLLOW') return 'warning'
      if (module === 'ENTRY_ROUTER') return 'info'
      return 'secondary'
    },
  },
}
</script>

<style scoped>
.studio-metric {
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  padding: 12px 14px;
  min-height: 72px;
  background: #fff;
}
.studio-metric small {
  display: block;
  color: #6e6b7b;
  margin-bottom: 6px;
}
.studio-metric strong {
  font-size: 18px;
}
.studio-metric--audit {
  background: #fcfcfe;
  min-height: 78px;
}
.test-studio-lifecycle-alert {
  border: 1px solid #f3e4b4;
}
.test-studio-lifecycle-line + .test-studio-lifecycle-line {
  margin-top: 0.45rem;
}

.test-studio-eligibility {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 0.9rem 1rem;
  background: #fcfcfe;
}

.test-studio-eligibility-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
}

.test-studio-eligibility-metric {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 0.75rem 0.8rem;
  background: #fff;
}

.test-studio-eligibility-metric span {
  display: block;
  color: #6e6b7b;
  font-size: 0.8rem;
  margin-bottom: 0.25rem;
}

.test-studio-eligibility-metric strong {
  display: block;
  color: #5e5873;
  font-size: 1.05rem;
}

@media (max-width: 991.98px) {
  .test-studio-eligibility-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .test-studio-eligibility-grid {
    grid-template-columns: 1fr;
  }
}
</style>
